
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","stroke-linejoin":"round","d":"M10.586 11.498a2.27 2.27 0 0 0 3.235-.305l1.21-1.5a2.273 2.273 0 0 0-2.014-3.658 2.27 2.27 0 0 0-1.52.804l-.432.537m.955 2.385a2.27 2.27 0 0 0-3.157.369l-1.401 1.706a2.273 2.273 0 0 0 2.013 3.657 2.27 2.27 0 0 0 1.52-.804l.567-.704"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"M4.602 13.58a6.506 6.506 0 1 1 8.106-10.083M8.506 6.173H2.009M5.46 9.906H2.193"}}),_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"M5.491 9.904c-.168-1.574-.089-3.23.22-4.677.313-1.46.827-2.551 1.4-3.14.282-.29.547-.427.777-.467.223-.04.463.003.724.168.554.35 1.122 1.203 1.528 2.535"}})])
          )
        }
      }
    